import React from 'react';
import { IonHeader, IonToolbar, IonTitle, IonButtons, IonButton } from '@ionic/react';

interface WebHeaderProps {
  title: string;
}

export const WebHeader: React.FC<WebHeaderProps> = ({ title: _title }) => {
  return (
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonButton routerLink="/Home" fill="clear">
            <img
              src="/assets/WerkAppYellow.png"
              alt="WerkApp"
              style={{ height: 32, width: 32, objectFit: 'cover', borderRadius: 8 }}
            />
          </IonButton>
        </IonButtons>
        <IonTitle>WerkApp</IonTitle>
        <IonButtons slot="end">
          {/* Add any global actions here */}
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default WebHeader;
